export default {
      id: "oc-res-servertemplate-baremetal-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-servertemplate-baremetal",
      toString: function () {
        return this.url;
      }
    }